import { Component,OnInit  } from '@angular/core';
import { NavController,Refresher,NavParams,LoadingController,ToastController,AlertController} from 'ionic-angular';
import { DTOCartelaPendente } from '../../dto/dtoCartelaPendente';
import { DTOInformacaoUsuario } from '../../dto/dtoInfomacaoUsuario';
import { PedidoDAO } from '../../daos/pedido-dao';
import _ from 'lodash';
@Component({
    selector: 'page-receber-cartela',
    templateUrl: 'receber-cartela.html'
})
export class ReceberCartelaPage implements OnInit {
    public usuario: DTOInformacaoUsuario = new DTOInformacaoUsuario();
    public cartelaPendente: DTOCartelaPendente[] = [];
    public cartelaPendenteOriginal: DTOCartelaPendente[] = [];
    public tipoPremiacao: string;
    searchTerm: string;
    constructor(public navCtrl: NavController,private _loadingCtrl: LoadingController,
        private _toastCtrl: ToastController,private _alertCtrl: AlertController
        ,private _pedidoDao: PedidoDAO,
        _navParams: NavParams) {  
            this.usuario = _navParams.get('usuario'); 
 
    }

    ngOnInit(): void {
        this.obterLista();
        
    }

    public obterLista(refresher?: Refresher): void {
        let load = this._loadingCtrl.create({ content: 'Obtendo Lista Cartela...' });
        if (!refresher)
            load.present();
            this._pedidoDao.listaCartelaPendente(this.usuario.Empresa.Id).then(lstCartela => {        
                this.cartelaPendenteOriginal = lstCartela;        
                this.cartelaPendente = lstCartela.filter(a => _.isEqual(a.TipoPremiacao, 'BRINDE'));             
                if (!refresher) load.dismiss(); else refresher.complete();
            }).catch(error => {
                    console.error(error);
                    if (!refresher) load.dismiss(); else refresher.complete();
                    this._toastCtrl.create({
                        message: 'Ocorreu um erro ao tentar obter o lista de cartela pendente. Tente novamente!',
                        duration: 3000
                    }).present();        
            });          
        
    }

    public receberCartela(item): void {  
        this._pedidoDao.receberCartelaPendente(item)
            .then(r => {
                this.alertaDeSucesso('Cartela Recebida!');
            }, err => {
                this.alertaErro(`Houve um erro inesperado. ${err.mensagem}`);
            });      

        const index = this.cartelaPendente.indexOf(item);
        this.cartelaPendente.splice(index, 1);        
    }

    public consultaTipoPremiacao(): void {
        var lista = this.cartelaPendenteOriginal;
        this.cartelaPendente = lista.filter(a => _.isEqual(a.TipoPremiacao, this.tipoPremiacao));             
    }

    alertaDeSucesso(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Sucesso 😀 ️',
            buttons: [{
                text: 'Ok'
            }]
        }).present();
    }

    alertaErro(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Ops... 😔',
            buttons: [{
                text: 'Ok, estou ciente'
            }]
        }).present();
    }

    

    


}


// WEBPACK FOOTER //
// ./src/pages/receber-cartela/receber-cartela.ts